import React from 'react';
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';

import { ChartCard } from '../components/ChartCard';
import { DepartmentCockpit } from '../components/DepartmentCockpit';
import { revenueTrend } from '../lib/mock-data';

export function FinancePage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="finance"
        pageTitle="Financial Performance"
        pageEyebrow="Finance Dashboard"
        pageDescription="Revenue, margin, cash and variance - sourced from ERP via API and modeled in Power BI."
      >
        {() => <FinanceCharts />}
      </DepartmentCockpit>
    </div>
  );
}

function FinanceCharts() {
  const data = revenueTrend;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-2">
      <ChartCard
        title="Revenue Trajectory"
        subtitle="vs Forecast"
        className="lg:col-span-2 h-[300px]"
      >
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
          >
            <defs>
              <linearGradient
                id="finRev"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop
                  offset="0%"
                  stopColor="oklch(0.78 0.18 195)"
                  stopOpacity={0.5}
                />
                <stop
                  offset="100%"
                  stopColor="oklch(0.78 0.18 195)"
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>

            <CartesianGrid
              stroke="var(--color-border)"
              vertical={false}
            />

            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />

            <YAxis
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />

            <Tooltip
              contentStyle={{
                background: 'var(--color-popover)',
                border: '1px solid var(--color-border)',
                borderRadius: 8,
                fontSize: 12,
              }}
            />

            <Area
              type="monotone"
              dataKey="revenue"
              stroke="oklch(0.78 0.18 195)"
              strokeWidth={2.5}
              fill="url(#finRev)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>
  );
}
